import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Row,
  Input,
  Table,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import AdminHeader from "components/Headers/AdminHeader";
import { DEFAULT_RECORDS_PER_PAGE } from "components/constant";
import CommonTable from "components/CommonComponents/ReactTable/Table";
import { getVisitorsByID } from "action/visitor";
import { useDispatch, useSelector } from "react-redux";
import { visitorDetails } from "constants/visitor";
import { urlDecodedId } from "components/CommonComponents/encodeDecodeFunction";

function VisitDetails() {
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const role = authData?.role;
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [expandedRowId, setExpandedRowId] = useState(null);

  const [pageNum, setPageNum] = useState(1);
  const visitorDetailsData = useSelector(
    (state) => state.visitors.visitorDetails,
  );
  //decode id here from url
  const decodedId = id ? urlDecodedId(id) : null;
  const formattedVisitorDetailsList =
    visitorDetailsData?.data?.visitorDetail?.map((item, index) => {
      return {
        ...item,
        srNo:
          (pageNum - 1) *
            (visitorDetailsData?.data?.noOfRecordsPerPage ||
              DEFAULT_RECORDS_PER_PAGE) +
          index +
          1,
      };
    });

  const [visitorDetailsState, setVisitorDetailsState] = useState({
    isLoading: false,
    isSearched: false,
    error: "",
    noRecords: false,
  });
  const [searchState, setSearchState] = useState({
    searchString: "",
  });

  useEffect(() => {
    if (decodedId) {
      setVisitorDetailsState((prev) => ({
        ...prev,
        isLoading: true,
        error: "",
      }));
      getVisitorsByID(dispatch, decodedId, pageNum, searchState.searchString);
      return () => {
        dispatch({ type: visitorDetails, payload: {} });
      };
    }
  }, [dispatch, decodedId, pageNum, searchState.filterParams]);

  //to check the visitorList response and till the time show loader or error as per response
  useEffect(() => {
    if (visitorDetailsData?.code === 200) {
      setVisitorDetailsState({
        isLoading: false,
        isSearched: false,
        error: "",
        noRecords: visitorDetailsData?.data?.visitorDetail?.length === 0,
      });
    } else if (visitorDetailsData?.code || visitorDetailsData?.message) {
      setVisitorDetailsState({
        isLoading: false,
        isSearched: false,
        error:
          visitorDetailsData?.message ||
          "Failed to load visitor list! Please try again.",
        noRecords: false,
      });
    }
  }, [visitorDetailsData]);

  const clearSearch = () => {
    setVisitorDetailsState((prev) => ({
      ...prev,
      isSearched: false,
      isLoading: false,
    }));
    setSearchState({
      searchString: "",
    });
    if (pageNum !== 1) setPageNum(1);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  const handleSearch = () => {
    if (!searchState.searchString.trim()) {
      return;
    }

    const newfilterParams = { searchString: searchState.searchString || "" };

    if (
      JSON.stringify(searchState.filterParams) !==
      JSON.stringify(newfilterParams)
    ) {
      setVisitorDetailsState((prev) => ({
        isLoading: true,
        isSearched: true,
      }));
      setSearchState((prev) => ({
        ...prev,
        filterParams: newfilterParams,
      }));
      if (pageNum !== 1) setPageNum(1);
    }
  };

  const handleRowClick = (row) => {
    if (!isRowExpandable(row.original)) return;
    setExpandedRowId((prev) => (prev === row.original.id ? null : row.original.id));
  };

  const columns = [
    {
      Header: "Sr No",
      accessor: "srNo",
    },
    {
      Header: "Search Jointer ID",
      accessor: "jointerId",
      Cell: ({ value }) => <span>{value || "-"}</span>,
    },
    {
      Header: "Search Certificate No",
      accessor: "certificateNo",
      Cell: ({ value, row, isExpanded }) => {
        const hasDetails =
          Array.isArray(row.original.visitorSearchResults) &&
          row.original.visitorSearchResults.length > 0;

        return (
          <span
            className={`${hasDetails && "cursor"}`}
            onClick={() => handleRowClick(row)}
          >
            {value || "-"}
            {hasDetails && (
              <strong className="text-primary ml-1">
                {isExpanded ? "View Less" : "View More"}{" "}
              </strong>
            )}
          </span>
        );
      },
    },
    {
      Header: "Search Name",
      accessor: "jointerName",
    },
    {
      Header: "Search by QR",
      accessor:"searchByQR",
      // Cell: ({ value, row }) => {
      //   const searchByQR =
      //     !row.original.jointerId && !row.original.certificateNo;

      //   return <span>{searchByQR ? "YES" : "NO"}</span>;
      // },
    },
    {
      Header: "Search On",
      accessor: "visitDateTime",
    },
  ];

  const ExpandedVisitorSearch = ({ row }) => {
    const jointerName = row.jointerName;
    const certificateNo = row.certificateNo;
    return (
      <div className="expanded-container">
        <div className="expanded-header">
          <h4>Group Certificate Search Details: </h4>
          <h5>
            Certificate No: <strong>{certificateNo || "-"}</strong> and Name:
            <strong> {jointerName || "-"}</strong>
          </h5>
          <h5 className="text-muted mb-2">
            This certificate is linked to multiple jointers. Showing details for
            the selected jointer.
          </h5>
        </div>

        <Table responsive size="md" className="expanded-table">
          <thead className="thead-light">
            <tr>
              <th>SR No</th>
              <th>Search Jointer ID</th>
              <th>Search Certificate ID</th>
              <th>Search Name</th>
              <th>Search On</th>
            </tr>
          </thead>
          <tbody>
            {row.visitorSearchResults.map((item, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{item.jointerID || "-"}</td>
                <td>{item.certificateID || "-"}</td>
                <td>{item.jointerName || "-"}</td>
                <td>{item.createdAt || "-"}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  };

  const isRowExpandable = (row) =>
    Array.isArray(row.visitorSearchResults) &&
    row.visitorSearchResults.length > 0;

  return (
    <>
      <AdminHeader name="Visitor Search History" />
      <Container fluid className="mt--6">
        <Row>
          <Col md="12">
            <Card>
              {/* Header */}
              <CardHeader className="d-flex align-items-center justify-content-start">
                <i
                  className="fa-solid fa-chevron-left mr-2 cursor"
                  onClick={() =>
                    navigate(
                      role === "SUPER_ADMIN"
                        ? "/super-admin/visitors"
                        : "/admin/visitors",
                    )
                  }
                />
                <CardTitle tag="h3" className="mb-0">
                  Visitor Name: {visitorDetailsData?.data?.visiterName}
                </CardTitle>
              </CardHeader>

              {/* Body */}
              <CardBody>
                {visitorDetailsData?.data?.totalRecords ? (
                  <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap flex-column flex-md-row">
                    {/* Left side - Filter Inputs + Search */}
                    <div className="d-flex flex-wrap align-items-center filter-group">
                      <Input
                        type="text"
                        placeholder="Search by jointer ID, name"
                        className="mr-2 mb-2 filter-input-large"
                        value={searchState.searchString}
                        onChange={(e) =>
                          setSearchState((prev) => ({
                            ...prev,
                            searchString: e.target.value,
                          }))
                        }
                        onKeyDown={handleKeyDown}
                      />

                      <Button
                        color="default"
                        // className="d-flex align-items-center btn-deep-blue mb-0"
                        className="d-flex justify-content-center align-items-center mb-1 filter-btn btn-deep-blue"
                        onClick={handleSearch}
                        disabled={visitorDetailsState.isSearched} //diabled the btn when loading
                      >
                        {visitorDetailsState.isSearched ? (
                          <>
                            <i className="fa fa-spinner fa-spin loader fa-xl" />{" "}
                          </>
                        ) : (
                          <>
                            <i className="fa fa-search mr-1" /> Search
                          </>
                        )}
                      </Button>

                      {searchState.filterParams?.searchString?.trim() && (
                        <Button
                          color="default"
                          className="d-flex align-items-start mb-1 ml-0 filter-btn btn-deep-blue px-4"
                          onClick={clearSearch}
                        >
                          <i className="fa fa-times mr-1 mt-1" /> Clear
                        </Button>
                      )}
                    </div>
                  </div>
                ) : null}
                <div className="mt-2 mb-3 mx-1">
                  {visitorDetailsData?.data?.totalRecords ? (
                    <>
                      {searchState.filterParams?.searchString?.trim() ? (
                        <span className="font-weight-bold">
                          Showing {visitorDetailsData?.data?.filteredRecords} of{" "}
                          {visitorDetailsData?.data?.totalRecords} Searches
                        </span>
                      ) : (
                        <span className="font-weight-bold">
                          Total Searches :{" "}
                          {visitorDetailsData?.data?.totalRecords}
                        </span>
                      )}
                    </>
                  ) : null}
                </div>
                {visitorDetailsState.isLoading ? (
                  <div className="loaderContainer">
                    <i className="fa fa-spinner fa-spin fa-2xl loader" />
                  </div>
                ) : visitorDetailsState.error ? (
                  <>
                    <div className="loaderContainer">
                      {visitorDetailsState.error}
                    </div>
                  </>
                ) : visitorDetailsState.noRecords ? (
                  <div className="loaderContainer text-muted">
                    No visitor searches found.
                  </div>
                ) : (
                  <CommonTable
                    columns={columns}
                    data={formattedVisitorDetailsList || []}
                    defaultPageSize={DEFAULT_RECORDS_PER_PAGE}
                    activePage={pageNum}
                    setPageNum={setPageNum}
                    totalPages={Math.ceil(
                      (visitorDetailsData?.data?.filteredRecords || 0) /
                        (visitorDetailsData?.data?.noOfRecordsPerPage ||
                          DEFAULT_RECORDS_PER_PAGE),
                    )}
                    showPaginationBottom={true}
                    expandedRowIndex={expandedRowId}
                    renderExpandedRow={(row) =>
                      isRowExpandable(row) ? (
                        <ExpandedVisitorSearch row={row} />
                      ) : null
                    }
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default VisitDetails;
